// extracted by mini-css-extract-plugin
module.exports = {"amount":"BalanceDue_amount__1kKmh","list":"BalanceDue_list__2Brbv","listRow":"BalanceDue_listRow__2_u37","total":"BalanceDue_total__OTNd8"};